module.exports = __webpack_public_path__ + "img/parallax.ed672ac9.png";